export default {
	init() {
	// JavaScript to be fired on all pages


		// Set Animated Link Span Width
		if($(".denver-public-art-page .top form ul.foot li").length > 0){
			$(".denver-public-art-page .top form ul.foot li").each(function(){
				var linkWidth = $(this).width() + (parseInt($(this).css("padding-left")) * 2) + 20;
				$(this).children("span").css({
					width: linkWidth * 2,
					height: linkWidth * 2,
					lineHieght: linkWidth * 2,
					left: (-1 * linkWidth) / 2
				})
			})
		}

		// Animated Link Hover Effect
		$(".denver-public-art-page .top form ul.foot li").hover(function(){
			var linkWidth = $(this).width() + (parseInt($(this).css("padding-left")) * 2) + 20;
			var textColor = $(this).css("color");
			$(this).addClass("hovering");
			if($(this).hasClass("checked")){
				$(this).children("span").css({
					boxShadow: "inset 0px 0px 0px " + linkWidth + "px #fff"
				});
				$(this).css("color", "#6442a3");
			}else {
				$(this).children("span").css({
					boxShadow: "inset 0px 0px 0px " + linkWidth + "px " + textColor
				});
				$(this).removeAttr("style");
			}
		},function(){
			$(this).removeClass("hovering");
			$(this).children("span").css({
				boxShadow: "none"
			});
			if($(this).hasClass("checked")){
				$(this).css("color", "#fff");
			}else{
				$(this).removeAttr("style");
			}
		});
		
		$(".denver-public-art-page .top form ul.foot li").on("focus", function(){
			var linkWidth = $(this).width() + (parseInt($(this).css("padding-left")) * 2) + 20;
			var textColor = $(this).css("color");
			$(this).addClass("hovering");
			if($(this).hasClass("checked")){
				$(this).children("span").css({
					boxShadow: "inset 0px 0px 0px " + linkWidth + "px #fff"
				});
				$(this).css("color", "#6442a3");
			}else {
				$(this).children("span").css({
					boxShadow: "inset 0px 0px 0px " + linkWidth + "px " + textColor
				});
				$(this).removeAttr("style");
			}
		});
		
		$(".denver-public-art-page .top form ul.foot li").on("blur", function(){
			$(this).removeClass("hovering");
			$(this).children("span").css({
				boxShadow: "none"
			});
			if($(this).hasClass("checked")){
				$(this).css("color", "#fff");
			}else{
				$(this).removeAttr("style");
			}
		});

		// svg
		$('img.svg').each(function () {
			var $img = $(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');
			$.get(imgURL, function (data) {
				var $svg = $(data).find('svg');
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}
				$svg = $svg.removeAttr('xmlns:a');
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
				}
				$img.replaceWith($svg);
			}, 'xml');
		});

	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	
	},

};



// WEBPACK FOOTER //
// ./scripts/routes/common.js